type GroupMember = { id: number; groupIds?: number[] };

// Group ids that scope a member's counterpart picker (a patient's caregivers, a
// caregiver's patients): the member's own groups, else the fallback (the global
// group filter) when the member is not selected, unknown or outside every group.
export function resolveMemberGroupIds<T extends GroupMember>(
  memberId: number | undefined,
  list: T[] | undefined,
  fallback: number[],
): number[] {
  if (!memberId) return fallback;
  const ids = list?.find(m => m.id === memberId)?.groupIds;

  return ids && ids.length > 0 ? ids : fallback;
}

// True only for a member known to belong to no group. With groups enabled a shift
// needs a group shared by patient and caregiver, so such a member can be paired
// with nobody and the counterpart picker should offer nobody.
export function memberWithoutGroups(member: GroupMember | undefined): boolean {
  return member?.groupIds !== undefined && member.groupIds.length === 0;
}
